import axios from "axios";

export const retentionDocApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-retention-document`,
  headers: { "Content-Type": "application/json" },
});
